{
  "version": 1,
  "asset_id": "d1ee39e2-7f60-4939-87ee-6bb9ede8c077",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/d1ee39e2-7f60-4939-87ee-6bb9ede8c077/sleeve-amateur-3-440.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/d1ee39e2-7f60-4939-87ee-6bb9ede8c077/sleeve-amateur-3-440.webp",
  "original_filename": "sleeve-amateur-3-440.webp",
  "size": 27996,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:31Z"
}
